'use es6';

import { createSelector } from 'reselect';

const pageIndexSelector = state => state.pageIndex;

const totalPagesSelector = state => state.totalPages;

const pageNumberSelector = createSelector(pageIndexSelector, pageIndex => pageIndex + 1);
const previousPageDisabledSelector = createSelector(pageIndexSelector, pageIndex => pageIndex <= 0);
const nextPageDisabledSelector = createSelector(pageNumberSelector, totalPagesSelector, (pageNumber, totalPages) => pageNumber === totalPages);
export default createSelector(pageNumberSelector, previousPageDisabledSelector, nextPageDisabledSelector, (pageNumber, previousPageDisabled, nextPageDisabled) => ({
  pageNumber,
  previousPageDisabled,
  nextPageDisabled
}));